<template>
  <div class="s4 c1 tip" :class="tipClass" v-if="resp.detail&&resp.detail.tip" @click="goAd()">
    <div>{{resp.detail? resp.detail.tip.text:"" }}</div>
    <div class="viewDetail" v-if="viewDetail">
      查看详情
      <img src="../../static/ic_arrow_right_c1.png" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import util from '@/util/util'

export default {
  name: 'AdTip',
  props: {
    tipClass: {
      default: '',
      type: String
    },
    viewDetail: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapState('video', ['resp'])
  },
  methods: {
    goAd() {
      // console.log(
      //   '*************xie22 this.resp.detail.tip:',
      //   this.resp.detail.tip
      // )
      util.go(decodeURIComponent(this.resp.detail.tip.wxUrl))
    }
  }
}
</script>

<style scoped lang="scss">
.tip {
  background: #fadbd5;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
  &.blue {
    background: rgba(4,107,204,0.2);
    color: #046BCC;
  }
}

.viewDetail {
  margin-right: 30px;
}

.viewDetail img {
  width: 12px;
  height: 20px;
}
</style>
